/**
 * Featuring (paid promotion) of marketplace services.
 *
 * Publishing a service on the marketplace is always FREE.
 * Heat is only charged when a seller wants the service featured — shown in the
 * featured rows on the marketplace home, in category pages and at the top of
 * search results — for a chosen number of days.
 */
export type PromotionPlanKey = "days_5" | "days_30";

export interface PromotionPlan {
  key: PromotionPlanKey;
  days: number;
  heat: number;
  label: string;
  blurb: string;
  labelKey: string;
  blurbKey: string;
}

export const PROMOTION_PLANS: PromotionPlan[] = [
  {
    key: "days_5",
    days: 5,
    heat: 10,
    label: "5 days",
    labelKey: "mpcopy.promo.days_5.label",
    blurbKey: "mpcopy.promo.days_5.blurb",
    blurb: "Short burst — featured for 5 days across the marketplace.",
  },
  {
    key: "days_30",
    days: 30,
    heat: 25,
    label: "30 days",
    labelKey: "mpcopy.promo.days_30.label",
    blurbKey: "mpcopy.promo.days_30.blurb",
    blurb: "Best value — a full month of featured placement.",
  },
];

export const PROMOTION_HEAT_CENTS = 433; // 1 Heat = US$1.00, billed in AED cents

export function promotionPlan(key: string): PromotionPlan | undefined {
  return PROMOTION_PLANS.find((p) => p.key === key);
}

export function isFeatured(featuredUntil: string | null | undefined): boolean {
  return Boolean(featuredUntil && new Date(featuredUntil).getTime() > Date.now());
}
